<template>
  <div class="p-menu">
    <!-- SP Screen --->
    <Panel title="期間" wrapper-class="hidden sm:block">
      <div class="date-wrapper flex gap-2.5 mb-2.5">
        <div class="field bolder-input has-calendar-icon">
          <a-input
            class="std-input-style"
            v-model="filterForm.checkInDate"
            placeholder="YYYY/MM/DD"
            @click="showPopUpCalendar = true"
            readOnly
          />
          <img :class="dataRange && 'content__xmark--active'" class="content__xmark" src="@/assets/icons/icon-xmark.svg" @click="calendarCancelClick"/>
        </div>
        <div class="from-text flex items-center justify-center">
          から
        </div>
        <ModalCalendar ref="modalCalendar" @ok="calendarData" :filterForm="filterForm" :visible="showPopUpCalendar"
          @cancel="showPopUpCalendar = false" :status="status" :disabled="!filterForm.checkInDate" />
      </div>
      <div class="content__rooms">部屋数</div>
      <ModalChildren @ok="peopleData" :filterForm="filterForm" :visible="showPopUpPeople"
        @cancel="showPopUpPeople = false" />

      <ActionBar @search="debounceSearch" @filter="showPopupFilter = true" />

      <div v-if="filterTags.length > 0" class="menu-tags pt-4">
        <a-space class="flex-wrap gap-y-2">
          <TagCustom round v-for="(tag, idx) in filterTags" :key="`filter-tag-${idx}`" @deleteTag="onDeleteTag(tag)">
            {{ tag.displayName }}
          </TagCustom>
        </a-space>
      </div>
    </Panel>

    <!-- PC Screen --->
    <Panel wrapper-class="px-2.5 py-1.5 mb-4 sm:hidden">
      <div class="menu-toolbar">
        <div class="toolbar-left">
          <div class="field bolder-input content__field">
            <a-input
              v-model="dataRange"
              size="large"
              placeholder="日付を指定して検索"
              @click="showPopUpCalendar = true"
              readOnly
            >
              <template #prefix>
                <img class="content__calendar" src="@/assets/icons/icon-calendar.svg" />
              </template>
            </a-input>
            <img :class="dataRange && 'content__xmark--active'" class="content__xmark" src="@/assets/icons/icon-xmark.svg" @click="calendarCancelClick"/>
          </div>
          <div class="field bolder-input">
            <a-input
              v-model="peopleOfRoom"
              size="large"
              @click="showPopUpPeople = true"
              placeholder="人数を指定して検索"
              readOnly
            >
              <template #prefix>
                <!-- <i class="icon icon-bor-people" /> -->
                <img
                  src="~@/assets/images/person-icon.svg"
                  alt="person icon"
                  class="flex" style="filter: grayscale(100%);width: 18px;"
                />
              </template>
            </a-input>
          </div>
          <!-- CRM汎用独自対応↓↓↓ -->
          <!-- <div class="field bolder-input">
            <a-input
              placeholder="こだわり条件を指定"
              size="large"
              @click="showPopupFilter = true"
              readOnly
            >
              <template #suffix>
                <i class="icon icon-bor-circle-plus icon-button text-xl" />
              </template>
            </a-input>
          </div> -->
          <!-- CRM汎用独自対応↑↑↑ -->
          <div class="c-input c-input--group">
            <button @click="debounceSearch" class="c-input__button rounded-sm h-full py-0 px-6 w-44 lg:w-auto">
              <icon name="action_search" class="mr-2" />
              <span>検索</span>
            </button>
          </div>
        </div>
      </div>
      <div v-if="filterTags.length > 0" class="menu-tags pt-4">
        <a-space class="flex-wrap gap-y-2">
          <TagCustom round v-for="(tag, idx) in filterTags" :key="`filter-tag-${idx}`"
            @deleteTag="onDeleteTag(tag)">
            {{ tag.displayName }}
          </TagCustom>
        </a-space>
      </div>
    </Panel>

    <PaginationWithCount wrapper-class="border-b-0 border-t-0" :items="plans" :pagination="pagination" @paging="paging" :showSort="true" @sortRecommend="getRecommendPlan" />


    <div class="sm:block">
      <!-- indexから利用可能なプランのみ返ってくる想定のためプランを直接指定 -->
      <div v-if="plans && plans.length > 0">
        <div class="menu-box m-0 p-0 mobile-menu-box" v-for="(plan, idx) in plans" :key="`plans-${idx}`">
          <div class="list-hotel">
            <div>
              <ListPlanItem :checkInDay="checkInDay" :hidePriceProps="false" :plan="plan" :pZaikoList="pZaikoList" :numPeople="numPeople"
                :stayNights="stayNights" :plansBenepoReturnInfo="plansBenepoReturnInfo" :filterForm="filterForm" />
            </div>
          </div>
        </div>
      </div>
      <div v-else class="py-40">
        <a-list :data-source="[]" />
        <div class="text-center">
          <span class="text-blank">
            検索条件に該当するプランが見つかりませんでした。<br />
            条件を変更して再度検索してください。
          </span>
        </div>
      </div>

      <PaginationWithCount wrapper-class="footer-pagination flex-col gap-y-3 sm:gap-y-2 border-t-0 border-b-0" :items="plans" :pagination="pagination"
      @paging="paging" :showSort="false"/>
    </div>

    <div class="sm:hidden block">
      <PlanFilterModal :visible="showPopupFilter" :filterForm="filterForm" :filterLabelMap="filterLabelMap"
        @ok="onFilterPopupOk" @cancel="cancelFilterForm" />
      <ModalChildren @ok="peopleData" :filterForm="filterForm" :visible="showPopUpPeople"
        @cancel="showPopUpPeople = false" />
      <!-- <ModalCalendar @ok="calendarData" :filterForm="filterForm" :visible="showPopUpCalendar" -->
      <!-- @cancel="showPopUpCalendar = false" :status="status" /> -->
    </div>
  </div>
</template>

<script>
import { get, minBy } from 'lodash'
import _ from 'lodash'
import cloneDeep from 'lodash/cloneDeep'
import isEqual from 'lodash/isEqual'
import pickBy from 'lodash/pickBy'
import debounce from 'lodash/debounce'
import forEach from 'lodash/forEach'
import moment from 'moment'
import useBreakpoints from '@/utils/useBreakpoints'
import { Panel, PaginationWithCount } from '@/components/compound'
import { Pagination } from '@/components/primitive'
import PlanFilterModal from '../components/PlanFilterModal'
import ActionBar from './components/ActionBar';
import ListPlanItem from '../components/ListPlanItem'
import filterProperties from '../components/filterPropertiesMock'
import ModalChildren from '../components/ChildrenAttach'
import ModalCalendar from '../components/ModalCalendar'
import TagCustom from './Tag'
import { getCookieValue } from '@/utils/cookie'
import axios from 'axios'
import { createSetCookie } from '@/utils/cookie'

const { width } = useBreakpoints()

export default {
  name: 'PlanList',
  components: {
    ListPlanItem,
    Pagination,
    PlanFilterModal,
    ModalChildren,
    ModalCalendar,
    TagCustom,
    Panel,
    ActionBar,
    PaginationWithCount
  },
  data() {
    return {
      priceFilter: false,
      plans: [],
      pagination: {
        total: 0,
        page: 1,
        size: 10
      },
      showPopupFilter: false,
      width,
      color: '#000',
      bgColor: '#f4f5f6',
      dataRange: null,
      numPeople: null,
      value: null,
      tagsText: [
        '現地決済予約',
        '事前決済予約',
        'カフェポイント',
        'すくすくえいど',
        '介護補助'
      ],
      // defaultの値をnullではなく、上限・下限なしの0に設定
      filterForm: {
        adultHeadCnt: 1,
        feeLower: "0",
        feeUpper: "0",
        roomCnt: 1
      },
      planData: {},
      showPopUpPeople: false,
      showPopUpCalendar: false,
      peopleOfRoom: null,
      checkOutDay: null,
      checkInDay: moment(new Date()),
      checkInDaySearch: null,
      excludeKeys: ['menuNo'],
      filterTags: [],
      stayNights: 1,
      status: null,
      debounceSearch: null,
      numbersFetchingInprogress: 0,
      pStompClient: null,
      pZaikoList: [],
      socket:null,
      mySet: new Set(),
      sortOrder: "PROPOSE",
      plansBenepoReturnInfo: [],
    }
  },

  created() {
    this.status = getCookieValue('BSVIEWER')
    const { checkInDate, stayNights, numPeople } = this.$route.query
    // クエリから表示するページを取得
    const page = Number(this.$route.query.planPage)
    if (page){
      this.pagination.page = page
    }
    this.stayNights = Number(stayNights) || 1
    const currenDate = moment().format('YYYY-MM-DD')

    const isBefore = moment(currenDate).isBefore(checkInDate)
    const isSame = moment(currenDate).isSame(checkInDate)

    if (checkInDate && (isBefore || isSame)) {
      this.checkInDay = moment(checkInDate).format('YYYY-MM-DD')
      this.checkOutDay = moment(checkInDate)
        .clone()
        .add(this.stayNights, 'days')
        .format('YYYY-MM-DD')
      this.dataRange = `${this.checkInDay}~${this.checkOutDay}`
    }

    this.numPeople = numPeople || 1

    if (this.$route.query) {
      const query = this.$route.query
      Object.keys(query).forEach((key) => {
        if (
          ![
            'checkInDate',
            'checkOutDate',
            'numPeople',
            'feeLower',
            'feeUpper',
            'roomCnt',
            'adultHeadCnt',
            'exUpperGradesHeadCnt',
            'exLowerGradesHeadCnt',
            'youjiAHeadCnt',
            'youjiBHeadCnt',
            'youjiCHeadCnt',
            'youjiDHeadCnt',
            'stayNights'
          ].includes(key) &&
          typeof query[key] === 'string'
        ) {
          query[key] = query[key].split(',')
        }
      })
      this.filterForm = { ...this.filterForm, ...query }
      //上限、下限の値で該当する値がなければ0にリセットする
      this.filterForm.feeUpper = filterProperties.data.feeUpper.some(item => item.value === this.filterForm.feeUpper)? this.filterForm.feeUpper : '0'
      this.filterForm.feeLower = filterProperties.data.feeLower.some(item => item.value === this.filterForm.feeLower)? this.filterForm.feeLower : '0'

      this.setDefaultData()
    }
    this.loadFilterTags()
    this.getList()
    this.debounceSearch = debounce(this.getList, 200)

  },

  watch: {},
  computed: {
    pageElementStart() {
      const { page, size, total } = this.pagination
      if (+total === 0) return 0
      return (page - 1) * size + 1
    },
    pageElementEnd() {
      const { total, page, size } = this.pagination
      return total > page * size ? page * size : total
    },
    filterLabelMap() {
      const map = {}
      Object.keys(filterProperties.data).forEach((key) => {
        if (Array.isArray(filterProperties.data[key])) {
          filterProperties.data[key].forEach((e) => {
            map[e.value] = e
          })
        }
      })
      return map
    },
    // TODO： indexの構造に合わせて修正が必要
    // 受付期間内、プランの公開期間内のプランを抜き出す処理
    // indexから返ってくるプランが受付期間内、公開期間内のものとすると不要になる
    // availablePlans() {
    //   return this.plans.filter((item) => {
    //     const applFlag = item.planUsage?.applFlag || null
    //     const rsvReceptEndDtTxt =
    //       item.planUsage?.usageDetailStay?.rsvReceptEndDtTxt || null
    //     const planStartDate = item.planBasicInfo?.planRcSttDt || null
    //     const planEndDate = item.planBasicInfo?.planRcEndDt || null
    //     return (
    //       this.checkRsvReceptEnd(applFlag, rsvReceptEndDtTxt) &&
    //       this.checkOutOfPlanRcDt(planStartDate, planEndDate)
    //     )
    //   })
    // },

  },
  beforeUnmount() {
    // WebSocket接続を切断する
    this.disconnectWebSocket();
  },
  methods: {
    // ソート順表示対応
    getRecommendPlan(val) {
      this.sortOrder = val;
      this.debounceSearch(this.getList, 200)
    },
    disconnectWebSocket() {
      this.socket.close();
      // console.log('WebSocket connection closed');
    },
    addDays(dateString, daysToAdd) {
                    // 日付オブジェクトを作成して日数を追加
                    var date = new Date(dateString);
                    date.setDate(date.getDate() + daysToAdd);

                    // 結果をYYYY/MM/DD形式の文字列に変換して表示
                    var year = date.getFullYear();
                    var month = ('0' + (date.getMonth() + 1)).slice(-2);
                    var day = ('0' + date.getDate()).slice(-2);
                    //alert(year + '-' + month + '-' + day);
                    return year + '/' + month + '/' + day;

                },
    togglePriceFilter() {
      this.priceFilter = !this.priceFilter
    },
    priceSort(sortOrder) {
      this.filterForm.searchSortBox = sortOrder === "LOWEST_PRICE" ? "LOWEST_PRICE" : "HIGHEST_PRICE";
      this.getList();
      this.debounceSearch = debounce(this.getList, 200);
      this.priceFilter = false;
    },
    setDefaultData() {
      const {
        roomCnt,
        adultHeadCnt,
        numPeople,
        exUpperGradesHeadCnt,
        exLowerGradesHeadCnt,
        youjiAHeadCnt,
        youjiBHeadCnt,
        youjiCHeadCnt,
        youjiDHeadCnt
      } = this.filterForm


      // 51861 子供検索対応 子供の人数を計算するように変更
      const s1Cnt = exUpperGradesHeadCnt === undefined ? 0 : exUpperGradesHeadCnt;
      const s2Cnt = exLowerGradesHeadCnt === undefined ? 0 : exLowerGradesHeadCnt;
      const y1Cnt = youjiAHeadCnt === undefined ? 0 : youjiAHeadCnt;
      const y2Cnt = youjiBHeadCnt === undefined ? 0 : youjiBHeadCnt;
      const y3Cnt = youjiCHeadCnt === undefined ? 0 : youjiCHeadCnt;
      const y4Cnt = youjiDHeadCnt === undefined ? 0 : youjiDHeadCnt;

      const childCount = +s1Cnt + +s2Cnt + +y1Cnt + +y2Cnt + +y3Cnt + +y4Cnt

      if (!!adultHeadCnt && !!numPeople) {
        const totalChild = `名子ども${+childCount}`
        this.peopleOfRoom = `大人${adultHeadCnt}${totalChild}名${+roomCnt > 0 ? roomCnt : 1
          }室`
      }
    },
    setQueryUrl({newPage} = {}) {
      // 比較用に再帰的に文字列に変換する内部関数
      const stringifyValues = (obj) => {
        const stringify = (value) => {
          if (_.isArray(value)) {
            return value.map(stringify)
          } else if(_.isObject(value)) {
            return _.mapValues(value, stringify)
          }
          return String(value)
        }

        return stringify(obj)
      }

      //比較用の変数
      let query = {}
      let org_query = {}
      Object.keys(this.filterForm)
        .filter((key) => !this.excludeKeys.includes(key))
        .forEach((e) => {
          if (Array.isArray(this.filterForm[e]) && this.filterForm[e].length > 0) {
            query[e] = this.filterForm[e].join(',')
          } else {
            query[e] = this.filterForm[e]
          }
        })
      Object.keys(this.$route.query)
      .filter((key) => !this.excludeKeys.includes(key))
      .forEach((e) => {
        if (Array.isArray(this.$route.query[e]) && this.$route.query[e].length > 0) {
          org_query[e] = this.$route.query[e].join(',')
        } else {
          org_query[e] = this.$route.query[e]
        }
      })

      //比較用にstringに変換
      query = stringifyValues(query)
      org_query = stringifyValues(org_query)
      // 検索条件、もしくは表示ページが変わっていた場合
      if (!isEqual(org_query, query) || newPage) {
        //検索条件が変わっていた場合、検索一覧ページのページ情報を削除し、ページを１ページ目に戻す
        if (!isEqual(this.$route.query, query)) {
          if (query.page){
            delete query.page
          }
          this.pagination.page = 1
          // top宿泊画面用の検索条件保持クッキー追加（検索条件が変わっていた場合のみ）
          document.cookie = createSetCookie('cr_stay_search_conditions', encodeURIComponent(JSON.stringify(query)), undefined, true)
        } else if(!newPage) {
          this.pagination.page = 1
        }

        // ページの反映
        if (newPage) {
          query['planPage'] = newPage
          this.pagination.page = newPage
        } else {
          query['planPage'] = this.pagination.page
        }
        // パンくずにqueryの変更を反映
        sessionStorage.setItem('previousUrl', JSON.stringify(query))
        const toFullPath = this.$router.resolve({
          path: this.$route.path,
          params: this.$route.params,
          query
        })?.href || ''

        if (this.$route.fullPath !== toFullPath) {
          this.$router.replace({
            path: this.$route.path,
            params: this.$route.params,
            query
          }).catch(() => {})
        }
      }
    },
    async getVacancyCalendar(menuNo, planId, roomId, queryParams) {
      let response;

      const endpoint =
        `${process.env.VUE_APP_AUTHORIZATION}/v1/stay/menu/${menuNo}/plans/${planId}/rooms/${roomId}/vacancy-calendar`;
      try {
        const checkInDay = moment(queryParams["checkInDay"]);
        const checkOutDay = moment(queryParams["checkOutDay"]);

        const fetchCalendar = (params) => axios.get(endpoint, { params });

        const mergeCalendars = (...responses) => ({
          data: {
            vacancyCalendars: responses.flatMap(r => r?.data?.vacancyCalendars ?? []),
          },
        });

        // 月またぎの場合、パラメータを変更して再度在庫取得APIコール
        if (!checkInDay.isSame(checkOutDay, 'month')) {
          const nextMonthStart = checkOutDay.clone().startOf('month').format('YYYY/MM/DD');

          const paramsThisMonth = { ...queryParams };
          const paramsNextMonth = { ...queryParams, checkInDay: nextMonthStart };

          const [resThisMonth, resNextMonth] = await Promise.all([
            fetchCalendar(paramsThisMonth),
            fetchCalendar(paramsNextMonth),
          ]);

          response = mergeCalendars(resThisMonth, resNextMonth);
        } else {
          response = await fetchCalendar(queryParams);
        }

        // 空室日付セット
        const availableDates = new Set(
          response['data']['vacancyCalendars'].map(item => item.stayDay)
        );
        // 宿泊日全てが空室日付セットに含まれているかチェック
        const checkInDayClone = checkInDay.clone();
        while (checkInDayClone.isBefore(checkOutDay)) {
          if (!availableDates.has(checkInDayClone.format('YYYY/MM/DD'))) {
            // 1日でも宿泊日が空室日付セットに無い場合、空室なしをpushして終了
            this.pushCheck(menuNo, planId, roomId, "空室なし");
            return;
          }
          checkInDayClone.add(1, 'days');
        }
        // 宿泊日の在庫数リスト
        const stocks = response['data']['vacancyCalendars']
          .filter(item => {
            const stayDay = moment(item.stayDay)
            return (stayDay >= checkInDay && stayDay < checkOutDay) && item.stock != null
          })
          .map(item => parseInt(item.stock))
        // 宿泊日のうちの最小在庫数
        const stockCount = stocks.length > 0 ? Math.min(...stocks) : null

        if (!stockCount || stockCount > 5) {
          return;
        }
        if (stockCount == 1) {
          this.pushCheck(menuNo, planId, roomId, "残り1部屋");
          return;
        }
        else if (stockCount <= 5) {
          let stock = "残り" + stockCount + "部屋";
          this.pushCheck(menuNo, planId, roomId, stock);
          return;
        }
      } catch (error) {
        let stock = "空室なし";
        this.pushCheck(menuNo, planId, roomId, stock);
      }
    },
    pushCheck(menuNo,planId,roomId,stock) {
      let found = false;
      for (let i = 0; i < this.pZaikoList.length; i++) {
        const zaikoUnit = this.pZaikoList[i];
        if (
          zaikoUnit['menuNo'] === menuNo &&
          zaikoUnit['planId'] === planId &&
          zaikoUnit['roomId'] === roomId
        ) {
          found = true;
          break; // 一致したらループを抜ける
        }
      }
      if(!found) {
        let zaikoUnit2 = {}; // ここで変数を初期化する必要があります
        zaikoUnit2['menuNo'] = menuNo;
        zaikoUnit2['planId'] = planId;
        zaikoUnit2['roomId'] = roomId;
        zaikoUnit2['stock'] = stock;
        this.pZaikoList.push(zaikoUnit2);

      }
    },
    async getList() {
      this.plansBenepoReturnInfo = []
      const { menuNo } = this.$route.params
      const { adultHeadCnt } = this.filterForm
      const queryPlanDetail = {
        adultHeadCnt: adultHeadCnt || 1
      }

      if (this.checkInDay) {
        queryPlanDetail.checkInDay = moment(this.checkInDay).format('YYYY/MM/DD')
      }
      if (this.checkOutDay) {
        queryPlanDetail.checkOutDay = moment(this.checkOutDay).format('YYYY/MM/DD')
      }
      if (this.dataRange) {
        this.filterForm['checkInDate'] = this.checkInDay
      }

      if (this.numPeople) {
        this.filterForm['numPeople'] = this.numPeople
      }

      if (this.stayNights) {
        this.filterForm['stayNights'] = this.stayNights
      }

      // ソート順パラメータ追加
      this.filterForm['searchSortBox'] = this.sortOrder

      // filterFormそのままではなく、filterFormからbodyを作成する
      const body = cloneDeep(this.filterForm)

      // 下限と上限の処理をメニュー一覧に合わせる
      if (this.filterForm.feeLower) {
        body.feeLower = this.filterForm.feeLower
      }
      if (body.feeLower == 0) {
        body.feeLower = 1
      }
      if (this.filterForm.feeUpper) body.feeUpper = this.filterForm.feeUpper
      if (body.feeUpper == 0) {
        body.feeUpper = 100000000; // #72331 で 100 万 → 1 億に変更。本来は上限を外したい意向だったが修正影響があるため上限引き上げの方針になった。
      }
      try {
        this.plans = []
        let res = await this.$repositories('plan')
          .searchPlan(
            this.pagination.page - 1,
            this.pagination.size,
            menuNo,
            body
          )
          .catch((error) => {
            return error
          })
        this.plans = res.plans || [];
        this.pagination.total = res.totalItems
        this.planData = res;

        // ModalCalendar内の空室情報を更新
        if (this.$refs.modalCalendar) {
          await this.$refs.modalCalendar.getVacancyCalendar();
        }

      } catch (err) {
        // console.log("🚀 ~ file: index.vue ~ line 470 ~ getList ~ err", err)
      }
      this.$nextTick(() => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      });
      this.pZaikoList = [];
      this.mySet = new Set();
      if ('checkInDate' in this.filterForm && this.filterForm['checkInDate'].length > 0) {
          var socketPrm = {};
          socketPrm['checkInDay'] = this.filterForm['checkInDate'].replaceAll('-', '/');
          socketPrm['checkOutDay'] = this.addDays(this.filterForm['checkInDate'],this.filterForm['stayNights'])
          socketPrm['roomCnt'] = this.filterForm['roomCnt'];
          socketPrm['adultHeadCnt'] = this.filterForm['adultHeadCnt'];
          socketPrm['exUpperGradesHeadCnt'] = this.filterForm['exUpperGradesHeadCnt'] == null ? 0 :this.filterForm['exUpperGradesHeadCnt'];
          socketPrm['exLowerGradesHeadCnt'] = this.filterForm['exLowerGradesHeadCnt'] == null ? 0 :this.filterForm['exLowerGradesHeadCnt'];
          socketPrm['youjiAHeadCnt'] = this.filterForm['youjiAHeadCnt'] == null ? 0 :this.filterForm['youjiAHeadCnt'];
          socketPrm['youjiBHeadCnt'] = this.filterForm['youjiBHeadCnt'] == null ? 0 :this.filterForm['youjiBHeadCnt'];
          socketPrm['youjiCHeadCnt'] = this.filterForm['youjiCHeadCnt'] == null ? 0 :this.filterForm['youjiCHeadCnt'];
          socketPrm['youjiDHeadCnt'] = this.filterForm['youjiDHeadCnt'] == null ? 0 :this.filterForm['youjiDHeadCnt'];
          var menus = []
          //console.log(this.plans);

          for (let i = 0; i < this.plans.length; i++) {
            if(!this.mySet.has(this.plans[i]['planId']+this.plans[i]['roomId'])) {
              this.mySet.add(this.plans[i]['planId']+this.plans[i]['roomId']);
              this.getVacancyCalendar(menuNo, this.plans[i]['planId'], this.plans[i]['roomId'], socketPrm);
            }
          }


        }
    },

    paging(page) {
      // pagingのevent受信⇒ページ変更⇒もう片方のpagingのevent発火の順番のため、２回目は動作しないように修正
      if (this.pagination.page != page){
        // pagingメソッド内でpageを変更すると、setQueryUrlと干渉して変更が反映されない場合があるため、setQueryUrl内でページを変更するように修正
        this.setQueryUrl({newPage: page})
        this.debounceSearch()
      }
    },

    loadFilterTags() {
      const tags = []
      Object.keys(this.filterForm)
        .filter((key) => !this.excludeKeys.includes(key))
        .forEach((key) => {
          if (Array.isArray(this.filterForm[key])) {
            this.filterForm[key].forEach((e) => {
              if (this.filterLabelMap[e] && this.filterLabelMap[e].searchParam !== 'planByCompany') {
                tags.push(this.filterLabelMap[e])
              }
            })
          } else if (this.filterLabelMap[key] && this.filterLabelMap[key].searchParam !== 'planByCompany') {
            tags.push(this.filterLabelMap[key])
          }
        })
      this.filterTags = tags
    },
    cancelFilterForm($event) {
      this.showPopupFilter = false
      this.filterForm = $event.filterForm
    },
    async onFilterPopupOk($event) {
      // const { adultHeadCnt } = this.filterForm
      this.showPopupFilter = false
      this.pagination.page = 1
      this.plans = $event.searchResult.plans || []
      this.pagination.total = $event.searchResult.totalItems
      this.planData = $event.searchResult;
      this.filterForm = $event.filterForm
      this.filterForm = { ...this.filterForm, ...$event.filters }
      this.setQueryUrl()
      this.loadFilterTags()
      this.debounceSearch(this.getList, 200)
    },
    onDeleteTag(tag) {
      const filterForm = cloneDeep(this.filterForm)
      Object.keys(filterForm).forEach((key) => {
        if (Array.isArray(filterForm[key])) {
          filterForm[key] = filterForm[key].filter((e) => e !== tag.value)
        } else if (key === tag.value) {
          delete filterForm[key]
        }
      })
      const filterTags = cloneDeep(this.filterTags)
      const filterTagsTmp = filterTags.filter((item) => item.value !== tag.value)
      const query = {}
      Object.keys(filterForm)
        .filter((key) => !this.excludeKeys.includes(key))
        .forEach((e) => {
          if (Array.isArray(filterForm[e]) && filterForm[e].length > 0) {
            query[e] = filterForm[e].join(',')
          } else {
            query[e] = filterForm[e]
          }
        })
      // top宿泊画面用の検索条件保持クッキー追加
      document.cookie = createSetCookie('cr_stay_search_conditions', encodeURIComponent(JSON.stringify(query)), undefined, true)
      this.$router.replace({
        path: this.$route.path,
        params: this.$route.params,
        query
      }).catch(() => {})
      this.filterForm = filterForm
      this.filterTags = filterTagsTmp
      this.setQueryUrl()
      this.debounceSearch()
    },
    calendarData(data) {
      this.showPopUpCalendar = false

      this.stayNights = data.stayNights
      const isDeleteDate = data.isDeleteDate
      if(isDeleteDate || !data.stayDays){
        this.calendarCancel(this.stayNights)
        return
      }

      const checkInDay = moment(data.stayDays)
      const checkOutDay = checkInDay.clone().add(data.stayNights, 'days')
        this.dataRange = `${checkInDay.format('YYYY/MM/DD')}~${checkOutDay.format(
        'YYYY/MM/DD'
      )}`
      this.checkInDay = checkInDay.format('YYYY-MM-DD')
      this.checkInDaySearch = checkInDay.format('YYYY/MM/DD')
      this.filterForm.checkInDate = this.checkInDay
      this.filterForm.stayNights = this.stayNights
      this.setQueryUrl()
      this.debounceSearch()
    },
    calendarCancelClick(){
      this.calendarCancel()
    },
    calendarCancel(date) {
      if (date){
        this.filterForm.stayNights = date
      } else{
        this.filterForm.stayNights = 1
      }
      
      delete this.filterForm.checkInDate

      this.dataRange = ''
      this.checkInDay = null

      this.setQueryUrl()
      this.getList()
    },
    peopleData(data) {
      const { countTotalChildren, filter } = data
      const totalChild = countTotalChildren ? `名子ども${countTotalChildren}` : ''
      this.numPeople = filter.numPeople
      this.peopleOfRoom = `大人${filter.adultHeadCnt}${totalChild}名${filter.roomCnt}室`
      this.showPopUpPeople = false
      this.filterForm = { ...this.filterForm, ...filter }
      this.setQueryUrl()
      this.debounceSearch()
    }
  }
}
</script>

<style lang="scss" scoped>
@import './styles.scss';

.pagination-right {
  width: 150px;
}

.a-select {
  width: 150px !important;
}

.ant-select-enabled {
  width: 150px;
}

::v-deep .bolder-input {
  .ant-input {
    border-color: gray;
  }
}

.content {
  &__field {
    position: relative;
  }
  &__calendar {
    width: 16px;
    height: 18px;
  }
  &__xmark {
    display: none;
    width: 18px;
    height: 18px;
    position: absolute;
    top: 50%;
    right: 2%;
    transform: translateY(-50%);
    &:hover {
      cursor: pointer;
    }
    &--active {
      display: inline;
    }
  }
}

@media (max-width: $contentWidthS) {
  .content {
    &__xmark {
      width: 18px;
      height: 18px;
      top: 48%;
    }
  }
}

@media only screen and (max-width: 638px) {
  .text_sp_base {
    font-size: 13px !important;
  }

  .content {
    &__rooms {
      margin-left: -10px;
      margin-right: -10px;
      border-radius: 0;
      background: #E7E7E7;
      font-weight: bold;
      padding: 4px 10px;
      font-size: 10px;
      line-height: 15px;
    }
  }
}
</style>